import { map, first } from 'rxjs/operators';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ArrayDataSource } from '../ui/arrayDataSource';
import * as _ from 'lodash';
import { StreamService } from '../services/stream.service';

@Component({
    styles: [`
        .mat-column-maxStreamSubscribers {
            max-width: 70px;
        }

        .mat-column-select {
            max-width: 50px;
            text-align: center;
        }

        .currentlySelected {
            color: #b0b0b0;
        }
    `],
    template: `
        <div mat-dialog-title>Select Products</div>
        <div mat-dialog-content>
            <div *ngIf="!availableProductsDataSource" fxLayoutAlign="center center" style="height: 100px;">
                <spinner></spinner>            
            </div>
            <mat-table *ngIf="availableProductsDataSource" #table [dataSource]="availableProductsDataSource">
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
                    <mat-cell *matCellDef="let row" [ngClass]="{ 'currentlySelected': productMatch(row.stream.id) }" 
                              matTooltip="Product already added"
                              matTooltipPosition="right"
                             [matTooltipDisabled]="!productMatch(row.stream.id)">{{row.stream.title}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="maxStreamSubscribers">
                    <mat-header-cell *matHeaderCellDef>Max Subscribers</mat-header-cell>
                    <mat-cell *matCellDef="let row" [ngClass]="{ 'currentlySelected': productMatch(row.stream.id) }"                            
                              matTooltip="Product already added"
                              matTooltipPosition="left"
                              [matTooltipDisabled]="!productMatch(row.stream.id)">
                        <mat-form-field *ngIf="!productMatch(row.stream.id)" style="width: 70px;">
                            <input matInput 
                                   type="number" 
                                   min="0"
                                   [disabled]="productMatch(row.stream.id)"
                                   [placeholder]="row.maxStreamSubscribers ? '' : 'unlimited'"
                                   (change)="(row.selected = true) && productSelectionChange()"
                                   [(ngModel)]="row.maxStreamSubscribers">
                        </mat-form-field>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="select">
                    <mat-header-cell *matHeaderCellDef>Add</mat-header-cell>
                    <mat-cell *matCellDef="let row"
                              matTooltip="Product already added"
                              matTooltipPosition="left"
                              [matTooltipDisabled]="!productMatch(row.stream.id)">
                        <mat-checkbox *ngIf="!productMatch(row.stream.id)"
                                      [disabled]="productMatch(row.stream.id)" 
                                      [checked]="productMatch(row.stream.id)"
                                      (change)="productSelectionChange()"
                                      [(ngModel)]="row.selected"></mat-checkbox>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: columns;"></mat-row>
            </mat-table>
        </div>
        <div mat-dialog-actions>
            <button mat-raised-button 
                    color="primary" 
                    [disabled]="!productsSelected" 
                    [mat-dialog-close]="selectedProducts()">Add</button>
            <button mat-button mat-dialog-close>Cancel</button>
        </div>
    `
})
export class AddProductsDialogComponent {
    availableProducts = [];
    availableProductsDataSource: ArrayDataSource;
    productsSelected = false;
    currentProducts: any;
    columns = ['name', 'maxStreamSubscribers', 'select'];

    constructor(private streamService: StreamService, @Inject(MAT_DIALOG_DATA) data: any) {
        this.currentProducts = data.ids;
        const params: { page, rows, includeCatalogs, excludeTypes?, type?} = { page: 0, rows: 500, includeCatalogs: false}
        if (data.limitProductSources) {
            params.excludeTypes = ['COLLECTION'];
        } else {
            params.type = 'COLLECTION';
            _.pull(this.columns, 'maxStreamSubscribers');
        }

        this.streamService.getTenantStreams(params)
        .pipe(
            first(),
            map(availableProductResults => availableProductResults.content.map(stream => ({ stream })))
        ).subscribe(availableProductResults => {
            this.availableProducts = availableProductResults;
            this.availableProductsDataSource = new ArrayDataSource(this.availableProducts);
        });
    }

    productMatch = id => this.currentProducts.indexOf(id) !== -1;

    selectedProducts = () => this.availableProducts.filter(product => product.selected);

    productSelectionChange = () => this.productsSelected =  !!this.selectedProducts().length;
};